const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Crie seu próprio",
  description: "",
  difficulty: "ALL",
  learnLang: "portuguese",
};

export default authorFromScratch;
